module.exports = __webpack_public_path__ + "img/zw.fe57a677.svg";